import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { sortCaret, headerSortingClasses } from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelected,
  createApproval,
  selectLoading,
} from "./warehouseSlice";
import { downloadFile } from "../chief-delivery/deliverySlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
} from "../../utility";
import Select from "react-select";
import InputNumber from "../../utility/InputNumber";
import { LayoutSplashScreen } from "../../../_metronic/layout";

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

export const WarehouseDetail = () => {
  const forceUpdate = useForceUpdate();
  const dispatch = useDispatch();
  const history = useHistory();
  const items = useSelector(selectSelected);
  const didRequest = useRef(false);
  const loading = useSelector(selectLoading);

  const [tableData, setTableData] = useState([]);
  const [btnDisabled, setbtnDisabled] = useState(false);

  useEffect(() => {
    const checkDataAvailable = async () => {
      try {
        if (!didRequest.current) {
          if (items.size < 1) {
            history.push("/chief-warehouse");
          } else {
            const getValueUom = (value, options) => {
              return options.filter((val) => value === val.uom);
            };

            const initData = items.items.map((item, index) => ({
              ...item,
              no: index + 1,
              actual_qty: parseFloat(item.qty),
              actual_uom: item.returnUom,
              remarkRow: "",
              defaulfUom: getValueUom(item.returnUom, item.altUom),
              FullBox: item.nonFraction === "Y" ? "Yes" : "No",
            }));

            // const initData2 = initData.map((item, index) => ({
            //   ...item,
            //   numerator: initData.defaulfUom[0].numerator,
            //   denumerator: initData.defaulfUom[0].denumerator
            // }));

            console.log(initData, "initdata");
            setTableData(initData);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        // setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (!didRequest.current) {
      checkDataAvailable();
    } else {
      // setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   tableData.forEach((item) => {
  //     const selected = item.altUom.filter((val) => item.uom === val.uom);
  //     const uom = selected[0];

  //     item.returnUom = (item.returnUom / uom.numerator) * uom.denumerator;
  //     item.returnUom = (item.returnUom / uom.numerator) * uom.denumerator;
  //   });
  //   setTableData(tableData);
  // }, [tableData]);

  // Return if data null
  if (items === null) {
    history.push("/chief-warehouse");
  }
  var retNumber, fpreDocId;
  if (items != null) {
    retNumber = items.retNumber;
    fpreDocId = items.fpreAttachmentId;
  }
  console.log(tableData, "tabledata");
  useEffect(() => {
    if (items === null) {
      return;
    }
    const id = items.fpreAttachmentId;
    if (items.fpreAttachmentId !== "") {
      setDocId(id);

      const getFileSize = async () => {
        const response = await dispatch(downloadFile(retNumber));
        const size = response.payload.length / 1000;
        setDocData([
          {
            id: 1,
            docName: `FPRE-${retNumber}.pdf`,
            file: retNumber,
            size: `${size} kb`,
          },
        ]);
      };
      getFileSize();
    }
  }, [retNumber]);

  // Add status field to prevent object is not extensible error

  const [remark, setRemark] = useState("");
  const [approvalCode, setApprovalCode] = useState("");
  const [docId, setDocId] = useState(fpreDocId);
  const [docData, setDocData] = useState([
    {
      id: 1,
      docName: `Not Uploat FPRE`,
      file: "-",
      size: ``,
    },
  ]);
  const [status, setStatus] = useState("R");

  // Return if data null
  // if (!tableData.length > 0) {
  //   history.push("/chief-warehouse");
  // }

  const handleSave = () => {
    // Validation
    let isValid = true;
    tableData.forEach((e) => {
      if (approvalCode === "") {
        console.log(e.approvalCode, "code");
        isValid = false;
        return showErrorDialog("Please select status doc first!");
      }
      if (approvalCode === "R" && remark === "") {
        isValid = false;
        return showErrorDialog("Please fill remark not oke first!");
      }
      if (e.status === "R" && e.remarkRow === undefined) {
        isValid = false;
        return showErrorDialog("Please fill remark reject first!");
      }
      if (parseFloat(e.actual_qty) > parseFloat(e.temp_actual_qty)) {
        isValid = false;
        return showErrorDialog(
          `Please do not exceed Requested Qty ${e.temp_actual_qty}!`
        );
      }
      if (e.actual_uom === "") {
        isValid = false;
        return showErrorDialog(`Please Input UOM!`);
      }
    });
    if (!isValid) return;
    setbtnDisabled(true);

    // Setup Request Body Params
    const items = tableData.map((e) => {
      return {
        approvalDetailId: e.approvalDetailId,
        qty: e.actual_qty,
        uom: e.actual_uom,
        remarkMaterial: e.remarkRow,
        status: e.status,
        remark: remark,
      };
    });

    const params = {
      retNumber: retNumber,
      payload: {
        fpreStatus: approvalCode,
        items: items,
      },
    };
    console.log("params", params);
    callApi(params);
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createApproval(params));
      if (response.payload.status === 200) {
        if (response.payload.data.data !== "") {
          const action = await showSuccessDialog(
            "Data has been saved!",
            `Return has been Saved, your Sales Order number : <strong>${response.payload.data.data}</strong>`
          );
        } else {
          const action = await showSuccessDialog(``);
        }

        await history.push("/chief-warehouse");
        setbtnDisabled(false);
      } else {
        setbtnDisabled(false);
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("error", error);
      setbtnDisabled(false);
    }
  };

  const handleRejectChange = (e, row, rowIndex, formatExtraData) => {
    console.log(e, "e");
    if (e === null) {
      formatExtraData[rowIndex].status = undefined;
    } else {
      formatExtraData[rowIndex].status = e.value;
    }
    setTableData(formatExtraData);
    forceUpdate();
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;

    if (row.status === "R") {
      classes = "textarea-red-border";
    } else {
      classes = "";
    }

    return classes;
  };

  const rejectFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Select
        className="action-approve-reject"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        options={[{ value: "R", label: "Reject" }]}
        onChange={(e) => {
          handleRejectChange(e, row, rowIndex, formatExtraData);
        }}
        placeholder="Select"
        isClearable={true}
      />
    );
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  // const [remarkRow, setRemarkRow] = useState("");

  // const handleRemarkRowChange = async (newValue, row, column, tableData) => {
  //   console.log(newValue, "newValue");
  //   console.log(row, "row");
  //   const uuid = row.uuid;
  //   let indexRow = "";
  //   tableData.filter((value, index) => {
  //     if (value.uuid == uuid) {
  //       indexRow = index;
  //     }
  //   });
  //   const availableQty_val = tableData[indexRow].remarkRow;

  //   tableData[indexRow].remarkRow = availableQty_val;
  //   console.log(availableQty_val, "input");

  //   const done = await setTableData(tableData);
  //   forceUpdate();
  //   return done;
  // };

  // const remarkFormatter = (newValue, row, column, tableData) => {
  //   return (
  //     <div>
  //       <Form.Control
  //         className={`remark-brqa ${
  //           row.status == "R" ? "textarea-red-border" : ""
  //         }`}
  //         as="textarea"
  //         placeholder="Leave a comment here"
  //         // value={remarkRow}
  //         style={{ height: "80px" }}
  //         onChange={(e) =>
  //           handleRemarkRowChange(newValue, row, column, tableData)
  //         }
  //         maxLength={255}
  //       />
  //     </div>
  //   );
  // };

  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].remarkRow = e.target.value;
    setTableData(formatExtraData);
    console.log("handle", formatExtraData);
  };

  const remarkFormatter = (cell, row, rowIndex, formatExtraData) => {
    console.log("remark", formatExtraData);
    return (
      <div>
        <Form.Control
          className={`remark-brqa ${
            row.status == "R" ? "textarea-red-border" : ""
          }`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          value={row.remarkRow}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };
  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (parseFloat(row.actual_qty) > parseFloat(row.qty)) {
      row.actual_qty = row.qty;
      forceUpdate();
      return;
    } else if (parseFloat(row.actual_qty) < 0) {
      row.actual_qty = 0;
      forceUpdate();
      return;
    }
  };

  const showField = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        step="any"
        className="input-qty-return"
        value={parseFloat(row.actual_qty)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  const handleQtyChange = async (newValue, row, column, tableData) => {
    const uuid = row.uuid;
    let indexRow = "";
    tableData.filter((value, index) => {
      if (value.uuid == uuid) {
        indexRow = index;
      }
    });
    const int_val = parseFloat(newValue);
    const availableQty_val = parseFloat(tableData[indexRow].actual_qty);

    if (int_val > availableQty_val) {
      forceUpdate();
      return;
    } else if (int_val < 0) {
      forceUpdate();
      return;
    }

    tableData[indexRow].actual_qty = int_val;

    const done = await setTableData(tableData);
    forceUpdate();
    return done;
  };

  // UOM Render
  const getValueUom = (value, options) => {
    const test = options.filter((val) => value === val.label);
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);

    const uom = selected[0];
    formatExtraData[rowIndex].actual_uom = e.value;

    const baseUom = formatExtraData[rowIndex].defaulfUom[0].uom;
    const fromNumerator = formatExtraData[rowIndex].defaulfUom[0].numerator;
    const fromDenumerator = formatExtraData[rowIndex].defaulfUom[0].denumerator;
    const selectedUom = uom.value;
    const toNumerator = uom.numerator;
    const toDenumerator = uom.denumerator;

    if (selectedUom === baseUom) {
      formatExtraData[rowIndex].actual_qty = formatExtraData[rowIndex].qty;
      formatExtraData[rowIndex].temp_actual_qty = formatExtraData[rowIndex].qty;
    } else if (fromNumerator >= fromDenumerator) {
      if (fromNumerator < toNumerator) {
        console.log("xx");
        formatExtraData[rowIndex].temp_actual_qty =
          formatExtraData[rowIndex].qty *
          (((fromNumerator * fromDenumerator) / toNumerator) * toDenumerator);
        formatExtraData[rowIndex].actual_qty =
          formatExtraData[rowIndex].qty *
          (((fromNumerator * fromDenumerator) / toNumerator) * toDenumerator);
      } else {
        console.log("yy");
        formatExtraData[rowIndex].temp_actual_qty =
          formatExtraData[rowIndex].qty *
          (fromNumerator * fromDenumerator * toNumerator * toDenumerator);
        formatExtraData[rowIndex].actual_qty =
          formatExtraData[rowIndex].qty *
          (fromNumerator * fromDenumerator * toNumerator * toDenumerator);
      }
    } else {
      if (fromNumerator < toNumerator) {
        console.log("zz");
        formatExtraData[rowIndex].temp_actual_qty =
          formatExtraData[rowIndex].qty *
          ((fromNumerator / fromDenumerator / toNumerator) * toDenumerator);
        formatExtraData[rowIndex].actual_qty =
          formatExtraData[rowIndex].qty *
          ((fromNumerator / fromDenumerator / toNumerator) * toDenumerator);
      } else {
        console.log("ss");
        formatExtraData[rowIndex].temp_actual_qty =
          formatExtraData[rowIndex].qty *
          ((fromNumerator / fromDenumerator) * toNumerator * toDenumerator);
        formatExtraData[rowIndex].actual_qty =
          formatExtraData[rowIndex].qty *
          ((fromNumerator / fromDenumerator) * toNumerator * toDenumerator);
      }
    }

    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.altUom;
    let cell_uom = cell;

    const options_this = [
      { value: "", label: "", numerator: "", denumerator: "" },
    ];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom,
        label: value.uom,
        numerator: value.numerator,
        denumerator: value.denumerator,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client",
      dataField: "clientName",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      editable: false,
      formatter: dateFormatter,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Sloc",
      dataField: "sloc",
      sort: true,
      sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Requested Qty",
      dataField: "qty",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "FullBox",
      dataField: "FullBox",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Return Uom",
      dataField: "returnUom",
      sort: true,
      editable: false,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Actual Qty",
      dataField: "actual_qty",
      type: "number",
      formatter: (cell, row, rowIndex) => showField(cell, row, rowIndex),
      editorRenderer: (
        editorProps,
        value,
        row,
        column,
        rowIndex,
        columnIndex
      ) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      formatExtraData: tableData,
    },

    {
      text: "UOM",
      dataField: "actual_uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: renderUom,
      formatExtraData: tableData,
      editable: false,
    },

    {
      text: "Nra",
      dataField: "nra",
      formatter: StatusFormatter,
      sort: true,
      editable: false,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Action Per Item ",
      dataField: "action",
      editable: false,
      formatter: rejectFormatter,
      formatExtraData: tableData,
    },
    {
      text: "Remark",
      dataField: "remarkRow",
      sort: true,
      sortCaret,
      headerSortingClasses,
      formatter: remarkFormatter,
      formatExtraData: tableData,
    },
  ];

  const fileFormmater = (cell, column, row) => {
    const url = `${process.env.REACT_APP_API_URL}/return/${retNumber}/fpre`;

    return (
      <span
        className={`label label-lg label-light-success label-inline cursor-pointer`}
        onClick={() => {
          if (cell === "-") {
            cell = "-";
          } else {
            window.open(url, "_blank").focus();
          }
        }}
      >
        {cell}
      </span>
    );
  };

  const columnsDoc = [
    {
      text: "Doc Name",
      dataField: "docName",
    },
    {
      text: "file",
      dataField: "file",
      formatter: fileFormmater,
    },
    {
      text: "Size",
      dataField: "size",
    },
    {
      text: "Action For All",
      dataField: "action",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <Select
            className="action-approve-reject"
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            options={[
              { value: "A", label: "FPRE OK" },
              { value: "R", label: "Not OK" },
            ]}
            onChange={(e) => {
              console.log(e.value, "selectnya");
              setApprovalCode(e.value);
            }}
            isSearchable={false}
            placeholder="Select"
          />
        );
      },
    },
    {
      text: "Remark",
      dataField: "remarkDoc",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <div>
            <Form.Control
              className="remark-brqa"
              as="textarea"
              placeholder="Leave a comment here"
              style={{ height: "80px" }}
              onChange={(e) => {
                console.log(e.target.value);
                setRemark(e.target.value);
              }}
            />
          </div>
        );
      },
    },
  ];

  return items === null ? null : loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Chief Warehouse Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="APL Return Number "
                    disabled
                    value={items.retNumber}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Invoice Ref Number"
                    disabled
                    value={items.invoiceNo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Doc Date</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Date"
                    disabled
                    value={formatDate(items.docDate)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Reason</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Reason"
                    disabled
                    value={items.reasonName}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    disabled
                    value={items.customerName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Customer Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Customer Code"
                    disabled
                    value={items.customerCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Plant Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control type="text" disabled value={items.plantName} />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>

          {/* Table Material*/}
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            keyField="approvalDetailId"
            data={tableData}
            columns={columns}
            hover
            rowClasses={rowClasses}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (row, column, rowIndex, columnIndex) => {},
              beforeSaveCell: (oldValue, newValue, row, column) => {},
              afterSaveCell: (oldValue, newValue, row, column) => {
                // handleQtyChange(newValue, row, column, tableData);
              },
            })}
          />
        </Form>

        {/* Table Docs Upload */}
        <Form.Group as={Row} className="mt-14">
          <Form.Label column sm={2}>
            <h3>Doc FPRE</h3>
          </Form.Label>

          <Col sm={8}>
            {docData.length > 0 && (
              <BootstrapTable
                classes="table table-head-custom table-vertical-center overflow-hidden"
                keyField="id"
                data={docData}
                columns={columnsDoc}
              />
            )}
          </Col>
        </Form.Group>

        <Form>
          <Row>
            <Col md="6" sm="6" lg="8">
              <Button
                variant="success"
                className="mr-5"
                disabled={btnDisabled}
                onClick={handleSave}
              >
                Save
              </Button>
              <Button
                variant="secondary"
                className="mr-5"
                onClick={() => history.push("/chief-warehouse")}
              >
                Back
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
};
